<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              需求信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogAddEditForm.typeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="市场">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求方">
                    <el-input
                      v-model="dialogAddEditForm.demandSide"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogAddEditForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogAddEditForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogAddEditForm.schemeTypeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="需求来源">
                    <el-input
                      v-model="dialogAddEditForm.schemeContent"
                      type="textarea"
                      disabled
                      autosize
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求开始日期">
                    <el-input
                      v-model="dialogAddEditForm.schemeStartDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求结束日期">
                    <el-input
                      v-model="dialogAddEditForm.schemeEndDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求物料名称">
                    <el-input
                      v-model="dialogAddEditForm.demandMaterialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求物料数量">
                    <el-input
                      v-model="dialogAddEditForm.demandMaterialsNumberUnit"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              申请信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="需求是否执行"
                    required
                  >
                    <el-radio-group v-model="dialogAddEditForm.isExecute">
                      <el-radio :label="1">
                        执行
                      </el-radio>
                      <el-radio :label="2">
                        不执行(不结算)
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.isExecute !== 2"
                  :span="12"
                >
                  <el-form-item label="需求执行方式">
                    <el-radio-group v-model="dialogAddEditForm.executeMethod">
                      <el-radio
                        v-if="dialogAddEditForm.demandSort === 1"
                        :label="1"
                      >
                        申请制作/购买
                      </el-radio>
                      <el-radio
                        v-if="dialogAddEditForm.demandSort === 1"
                        :label="2"
                      >
                        现有库存满足
                      </el-radio>
                      <el-radio
                        v-if="dialogAddEditForm.demandSort === 2"
                        :label="3"
                      >
                        外部租赁
                      </el-radio>
                      <el-radio
                        v-if="dialogAddEditForm.demandSort === 2"
                        :label="4"
                      >
                        自有物资满足
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAddEditForm.isExecute === 2"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item
                    label="不执行原因"
                    prop="ignoreReason"
                  >
                    <el-input
                      v-model="dialogAddEditForm.ignoreReason"
                      type="textarea"
                      placeholder="请输入不执行原因说明"
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAddEditForm.isExecute !== 2 && dialogAddEditForm.demandSort === 1"
                :gutter="10"
              >
                <el-col :span="12">
                  <el-form-item
                    label="需求满足物料"
                    prop="materialsId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.materialsId"
                      filterable
                      clearable
                      placeholder="请选择需求满足物料"
                      style="width:100%"
                      @change="materialsChangeFun"
                    >
                      <el-option
                        v-for="item in materialsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.typeValue }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.isExecute !== 2 && dialogAddEditForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="申请制作数量">
                    <el-input
                      v-model="dialogAddEditForm.applyMakeNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.isExecute !== 2 && dialogAddEditForm.executeMethod === 2"
                  :span="6"
                >
                  <el-form-item label="备用库存满足数量">
                    <el-input
                      v-model="dialogAddEditForm.applySpareStockMeetsNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    v-if="dialogAddEditForm.isExecute !== 2 && dialogAddEditForm.executeMethod === 2"
                    label="市场本地备用库存数量"
                  >
                    <el-input
                      v-model="dialogAddEditForm.spareStockNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAddEditForm.isExecute !== 2 && dialogAddEditForm.executeMethod === 1"
                :gutter="10"
              >
                <el-col :span="6">
                  <el-form-item
                    label="收货库房"
                    prop="receiveDepotId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.receiveDepotId"
                      filterable
                      clearable
                      placeholder="请选择收货库房"
                      style="width:100%"
                      @change="receiveDepotChangeFun"
                    >
                      <el-option
                        v-for="item in depotOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货人">
                    <el-input
                      v-model="dialogAddEditForm.receiver"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货联系电话">
                    <el-input
                      v-model="dialogAddEditForm.receivePhone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货地址">
                    <el-input
                      v-model="dialogAddEditForm.receiveAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row
                v-if="dialogAddEditForm.isExecute !== 2 && dialogAddEditForm.demandSort === 2"
                :gutter="10"
              >
                <el-col
                  v-if="dialogAddEditForm.executeMethod === 3"
                  :span="12"
                >
                  <el-form-item
                    label="租赁物料内容"
                    prop="leaseMaterials"
                  >
                    <el-input v-model="dialogAddEditForm.leaseMaterials" />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.executeMethod === 3"
                  :span="6"
                >
                  <el-form-item
                    label="租赁数量"
                    prop="leaseNumber"
                  >
                    <el-input
                      v-model="dialogAddEditForm.leaseNumber"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditForm, 'leaseNumber')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditForm, 'leaseNumber', 2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="租赁备注说明"
                    prop="leaseDirections"
                  >
                    <el-input v-model="dialogAddEditForm.leaseDirections" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 物料API
import { listMaterialsApi } from '@/api/v2/materials';
// 数据请求
import { initMaterialsDemandApi, saveMaterialsDemandApi } from '@/api/materialsDemandDetail'
import { depotListSelectDataApi } from '@/api/depot';
import { loadSpareInventoryDataApi } from '@/api/inventoryInfo'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    sendObject: {
      type: Object,
      default: null
    }
  },
  data () {
    // 物料租赁数量
    const validateLeaseNumber = (rule, value, callback) => {
      if (this.dialogAddEditForm.isExecute === 0 && this.dialogAddEditForm.demandSort === 2) {
        if (value === '') {
          callback(new Error('请输入物料租赁数量'))
        } else if (Number(value) > Number(this.dialogAddEditForm.demandMaterialsNumber)) {
          callback(new Error('物料租赁数量不能超过需求物料数量'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        materialsId: [{ required: true, message: '请选择需求满足物料', trigger: 'change' }],
        receiveDepotId: [{ required: true, message: '请选择收货库房', trigger: 'change' }],
        leaseType: [{ required: true, message: '请选择租赁类型', trigger: 'change' }],
        leaseMaterials: [{ required: true, message: '请输入租赁物料内容', trigger: 'blur' }, { max: 255, message: '租赁物料内容最多输入255个字符', trigger: 'blur' }],
        leaseNumber: [{ validator: validateLeaseNumber, trigger: 'blur' }],
        leaseDirections: [{ max: 255, message: '租赁备注说明最多输入255个字符', trigger: 'blur' }],
        ignoreReason: [{ required: true, message: '请输入忽略原因', trigger: 'blur' }, { max: 255, message: '忽略原因最多输入255个字符', trigger: 'blur' }],
        remark: [{ max: 255, message: '备注最多输入255个字符', trigger: 'blur' }]
      },
      materialsOptions: [],
      depotOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })

        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.materialsOptions = []
        this.depotOptions = []
        this.dialogAddEditForm = {
          type: 1,
          typeValue: '方案内需求',
          provinceId: 0,
          provinceName: '',
          cityId: 0,
          cityName: '',
          schemeId: 0,
          schemeName: '',
          schemeNo: '',
          schemeContent: '',
          schemeStartDate: '',
          schemeStartDateValue: '',
          schemeEndDate: '',
          schemeEndDateValue: '',
          demandSide: '',
          schemeType: 0,
          schemeTypeValue: '',
          schemeServiceId: 0,
          demandMaterialsId: 0,
          demandMaterialsName: '',
          demandMaterialsNumber: 0,
          demandMaterialsUnit: '',
          demandMaterialsNumberUnit: '',
          isExecute: 0,
          demandSort: 0, // 需求方式
          executeMethod: 0, // 需求执行方式
          materialsId: '',
          materialsName: '',
          materialsUnitId: 0,
          materialsUnitName: '',
          materialsSpecification: '',
          applySpareDepotId: '',
          applySpareDepotName: '',
          applySpareStockMeetsNumber: 0,
          applyMakeNumber: 0,
          receiveDepotId: '', // 制作物料收货库房ID
          receiveDepotName: '', // 制作物料收货库房名称
          receiverId: 0, // 制作物料收货人ID
          receiver: '', // 制作物料收货人姓名
          receivePhone: '', // 制作物料收货联系电话
          receiveAddress: '', // 制作物料收货地址
          leaseMaterials: '',
          leaseNumber: 0,
          leaseDirections: '',
          ignoreReason: '',
          remark: '',
          spareStockNumber: 0, // 本地库房备用库存数量
        }

        // 获取物料下拉选择项
        this.initMaterialsData()
        if (this.eventType !== 'add') {
          this.initData()
        } else {
          this.initAddData()
        }
      }
    }
  },
  methods: {
    // 根据方案物料初始化新增数据
    initAddData () {
      this.dialogAddEditForm = {
        type: 1,
        typeValue: '方案内需求',
        provinceId: this.sendObject.provinceId,
        provinceName: this.sendObject.provinceName,
        cityId: this.sendObject.cityId,
        cityName: this.sendObject.cityName,
        schemeId: this.sendObject.schemeId,
        schemeName: this.sendObject.schemeName,
        schemeNo: this.sendObject.schemeNo,
        schemeContent: this.sendObject.schemeContent,
        schemeStartDate: this.sendObject.schemeStartDateValue,
        schemeStartDateValue: this.sendObject.schemeStartDateValue,
        schemeEndDate: this.sendObject.schemeEndDateValue,
        schemeEndDateValue: this.sendObject.schemeEndDateValue,
        demandSide: this.sendObject.provinceName + '分中心',
        schemeType: this.sendObject.type,
        schemeTypeValue: this.sendObject.typeStr,
        schemeServiceId: this.sendObject.id,
        demandMaterialsId: this.sendObject.itemId,
        demandMaterialsName: this.sendObject.itemName,
        demandMaterialsUnit: this.sendObject.unit,
        demandMaterialsNumber: this.sendObject.amount,
        demandMaterialsNumberUnit: this.sendObject.amount + ' ' + this.sendObject.unit,
        isExecute: 1,
        demandSort: this.sendObject.type === 3 ? 2 : 1, // 需求方式
        executeMethod: this.sendObject.type === 3 ? 4 : 1, // 需求执行方式
        materialsId: '',
        materialsName: '',
        materialsUnitId: 0,
        materialsUnitName: '',
        materialsSpecification: '',
        applySpareDepotId: '',
        applySpareDepotName: '',
        applySpareStockMeetsNumber: this.sendObject.type === 3 ? 0 : this.sendObject.amount,
        applyMakeNumber: this.sendObject.type === 3 ? 0 : this.sendObject.amount,
        receiveDepotId: '', // 制作物料收货库房ID
        receiveDepotName: '', // 制作物料收货库房名称
        receiverId: 0, // 制作物料收货人ID
        receiver: '', // 制作物料收货人姓名
        receivePhone: '', // 制作物料收货联系电话
        receiveAddress: '', // 制作物料收货地址
        leaseMaterials: '',
        leaseNumber: this.sendObject.type === 4 ? 0 : this.sendObject.amount,
        leaseDirections: '',
        ignoreReason: '',
        remark: '',
        spareStockNumber: 0, // 本地库房备用库存数量
      }
      this.initDepotSelectData()
      this.loading = false
    },
    // 加载数据
    initData () {
      initMaterialsDemandApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditForm) {
          if (key.endsWith('Date')) this.dialogAddEditForm[key] = data[key + 'Value']
          else this.dialogAddEditForm[key] = data[key]
        }
        this.dialogAddEditForm.demandMaterialsNumberUnit = data.demandMaterialsNumber + ' ' + data.demandMaterialsUnit
        this.dialogAddEditForm.applySpareStockMeetsNumber = data.demandMaterialsNumber
        this.dialogAddEditForm.applyMakeNumber = data.demandMaterialsNumber
        if (data.receiveDepotId === 0) this.dialogAddEditForm.receiveDepotId = ''
        this.dialogAddEditForm.id = data.id

        this.initDepotSelectData()
        // 获取所属市场该物料的库存数量
        this.loadMaterialsSpareStockDataFun()
        this.loading = false
      })
    },
    // 获取物料下拉框数据
    initMaterialsData () {
      listMaterialsApi({ sortIds: '1, 2, 5', orderSort: 'sort_id, brand_id asc' }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.materialsOptions.push({
            label: item.name, value: item.id, sortId: item.sortId, unitName: item.minimumUnit, unitId: 0, specification: item.specification, typeValue: item.sortName + ' - ' + item.brandName
          })
        })
      })
    },
    // 选择物料回调
    materialsChangeFun (val) {
      let selectedItem = {}
      selectedItem = this.materialsOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.materialsName = selectedItem.label || ''
      this.dialogAddEditForm.materialsUnitId = selectedItem.unitId || 0
      this.dialogAddEditForm.materialsUnitName = selectedItem.unitName || ''
      this.dialogAddEditForm.materialsSpecification = selectedItem.specification || ''

      // 获取需求物料的备用库存数量
      this.loadMaterialsSpareStockDataFun()
    },
    // 初始市场本地仓库下拉数据
    initDepotSelectData () {
      depotListSelectDataApi({ status: "1", cityId: this.dialogAddEditForm.cityId, notManage: 'true' }).then(res => {
        res.data.forEach(item => {
          this.depotOptions.push({
            label: item.name,
            value: item.id,
            receiverId: item.receiverId || 0,
            receiverName: item.receiverName || '',
            receivePhone: item.phone || '',
            receiveAddress: item.receiveAddress || ''
          })
        })
      })
    },
    // 选择库房回调
    receiveDepotChangeFun (val) {
      let selectItem = {}
      selectItem = this.depotOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.receiveDepotName = selectItem ? selectItem.label : ''
      this.dialogAddEditForm.receiverId = selectItem ? selectItem.receiverId : 0
      this.dialogAddEditForm.receiver = selectItem ? selectItem.receiverName : ''
      this.dialogAddEditForm.receivePhone = selectItem ? selectItem.receivePhone : ''
      this.dialogAddEditForm.receiveAddress = selectItem ? selectItem.receiveAddress : ''
    },
    // 获取所属市场该物料的库存数量
    loadMaterialsSpareStockDataFun () {
      this.dialogAddEditForm.spareStockNumber = 0
      this.dialogAddEditForm.applySpareDepotId = 0
      this.dialogAddEditForm.applySpareDepotName = ''

      if (this.dialogAddEditForm.materialsId > 0) {
        this.loading = true
        let cityId = this.dialogAddEditForm.cityId;
        if (Number(this.dialogAddEditForm.provinceId) === 29) {
          cityId = 341
        } else if (Number(this.dialogAddEditForm.provinceId) === 9) {
          cityId = 98
        } else if (Number(this.dialogAddEditForm.provinceId) === 26) {
          cityId = 312
        }
        loadSpareInventoryDataApi({ cityId: cityId, materialsId: this.dialogAddEditForm.materialsId }).then(response => {
          const { data } = response
          let isBreak = false
          data.forEach(item => {
            if (isBreak) return
            if (item.amount > 0) {
              this.dialogAddEditForm.spareStockNumber = item.amount
              this.dialogAddEditForm.applySpareDepotId = item.depotId
              this.dialogAddEditForm.applySpareDepotName = item.depotName
              isBreak = true
            }
          })
          this.loading = false
        })
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          // 如果执行需求并且需求执行方式为现有库存满足
          if (this.dialogAddEditForm.isExecute === 1 && this.dialogAddEditForm.executeMethod === 2) {
            if (Number(this.dialogAddEditForm.spareStockNumber) < Number(this.dialogAddEditForm.applySpareStockMeetsNumber)) {
              this.$message({ message: '现有备用库存小于需求数量，不能保存', type: 'warning' })
              return false
            }
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '物料需求申请', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.operateButtonDisable = true
            this.loading = true
            this.loadingText = '正在处理数据中，请耐心等待'

            if (this.dialogAddEditForm.isExecute === 1) {
              this.dialogAddEditForm.ignoreReason = ''
              if (this.dialogAddEditForm.executeMethod === 1) { // 新制作/购买
                this.dialogAddEditForm.applySpareDepotId = ''
                this.dialogAddEditForm.applySpareDepotName = ''
                this.dialogAddEditForm.applySpareStockMeetsNumber = 0
              } else if (this.dialogAddEditForm.executeMethod === 2) { // 现有库存满足
                this.dialogAddEditForm.applyMakeNumber = 0
                this.dialogAddEditForm.receiveDepotId = ''
                this.dialogAddEditForm.receiveDepotName = ''
                this.dialogAddEditForm.receiverId = 0
                this.dialogAddEditForm.receiver = ''
                this.dialogAddEditForm.receivePhone = ''
                this.dialogAddEditForm.receiveAddress = ''
              } else if (this.dialogAddEditForm.executeMethod === 4) { // 自有物资满足
                this.dialogAddEditForm.leaseMaterials = ''
                this.dialogAddEditForm.leaseNumber = 0
              }
            } else {
              this.dialogAddEditForm.demandSort = 0
              this.dialogAddEditForm.executeMethod = 0
              this.dialogAddEditForm.applySpareDepotId = ''
              this.dialogAddEditForm.applySpareDepotName = ''
              this.dialogAddEditForm.applySpareStockMeetsNumber = 0
              this.dialogAddEditForm.applyMakeNumber = 0
              this.dialogAddEditForm.receiveDepotId = ''
              this.dialogAddEditForm.receiveDepotName = ''
              this.dialogAddEditForm.receiverId = 0
              this.dialogAddEditForm.receiver = ''
              this.dialogAddEditForm.receivePhone = ''
              this.dialogAddEditForm.receiveAddress = ''
              this.dialogAddEditForm.leaseMaterials = ''
              this.dialogAddEditForm.leaseNumber = 0
              this.dialogAddEditForm.leaseDirections = ''
            }

            saveMaterialsDemandApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
